import React from "react";
import { useSelector } from "react-redux";
import AddProduct from "../components/AddProduct";
import ProductCard from "../components/ProductCard";

const Home = () => {
  const { products } = useSelector((state) => state.product);

  return (
    <main className="py-16">
      <div className="productWrapper">
        <div className="productContainer" id="lws-productContainer">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
          {products.length ===0  && <h2 className="text-xl font-bold">No products found</h2>}
        </div>
        <div>
          <AddProduct />
        </div>
      </div>
    </main>
  );
};

export default Home;
